import type { ChakraTheme } from "@chakra-ui/react";
import type { Optional } from "utility-types";

export const transition: Optional<ChakraTheme["transition"]> = {
	easing: {
		aramcoCubic: "cubic-bezier(.35,1,.45,1)",
	}
};
